import "./GamesPage.css";
import pusoyImg from "../assets/games/pusoy.png";
import tongitsImg from "../assets/games/tongits.png";
import horseImg from "../assets/games/horse.png";

function GamesPage() {
  const games = [
    {
      id: 1,
      title: "Pusoy",
      description: "A classic Filipino card game.",
      image: pusoyImg,
    },
    {
      id: 2,
      title: "Tongits",
      description: "Fast-paced draw-and-discard game.",
      image: tongitsImg,
    },
    {
      id: 3,
      title: "Horse Race",
      description: "Bet on animated races!",
      image: horseImg,
    },
    {
      id: 3,
      title: "Bet Game/Mother-Mother",
      description: "5 card hand poker!",
      image: horseImg,
    },
  ];

  return (
    <div className="games-page">
      <h1>🎮 Available Games</h1>
      <div className="game-card-container">
        {games.map((game) => (
          <div className="game-card" key={game.id}>
            <img src={game.image} alt={game.title} className="game-image" />
            <h3>{game.title}</h3>
            <p>{game.description}</p>
            <button className="play-button">Play</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GamesPage;
